import { Services } from '@sigma-frontend-libs/commons'

import { buttonModes, components } from '@/utils'

import button from '@/components/button'
import tab from '@/components/services/eventsHistory/tab'

function renderDialogBody(h) {
  return h(
    tab,
    {
      props: {
        entityId: this.entityId
      }
    }
  )
}
function renderDialogFooter(h) {
  return h(
    'div',
    {
      class: 'fiac fjcfe pa-2',
      slot: 'footer'
    },
    [
      h(
        button,
        {
          props: {
            label: this.getTranslate('misc.buttons.close'),
            mode: buttonModes.flat
          },
          on: {
            click: () => {
              this.proxy = false
            }
          }
        }
      )
    ]
  )
}

export default function(h) {
  return h(
    components.dialog,
    {
      props: {
        title: this.getTranslate(`${Services.eventsHistory}.labels.eventsHistory`),
        value: this.proxy,
        maxWidth: this.$_dialogMaxWidth
      },
      on: {
        input: event => {
          this.proxy = event
        }
      }
    },
    [
      renderDialogBody.call(this, h),
      renderDialogFooter.call(this, h)
    ]
  )
}
